import React from "react";
import { Link } from "react-router-dom";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const normalizeCardUrl = (url) => {
    const u = sanitize(url);
    if (!u) return "#";
    if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("//")) return u;
    return u.startsWith("/") ? u : `/${u}`;
};

const OfferingsSection = ({ fields }) => {
    if (!fields) return null;

    const eyebrow = sanitize(fields.eyebrow);
    const title = sanitize(fields.title);
    const cards = Array.isArray(fields.cards)
        ? fields.cards.filter((card) => sanitize(card?.title) || sanitize(card?.description))
        : [];

    if (!eyebrow && !title && !cards.length) return null;

    return (
        <section className="offerings">
            <div className="canvas">
                <div className="offerings-wrap">

                    {(eyebrow || title) && (
                        <div className="offerings-head" data-stagger-index="0">
                            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
                            {title && <h2>{title}</h2>}
                        </div>
                    )}

                    {cards.length > 0 && (
                        <div className="offerings-cards">
                            {cards.map((card, index) => {
                                const backgroundStyle = card.image?.url
                                    ? { backgroundImage: `url(${card.image.url})` }
                                    : undefined;

                                const cardUrl = normalizeCardUrl(card?.url);
                                const isExternal = cardUrl.startsWith("http") || cardUrl.startsWith("//");

                                const cardContent = (
                                    <>
                                        <div className="off-overlay">
                                            {/* Blur layer */}
                                            <div className="off-blur-layer"></div>
                                            <div className="off-content">
                                                <div className="off-sub-content">
                                                    {sanitize(card.title) && <h3>{card.title}</h3>}
                                                    {sanitize(card.description) && <p>{card.description}</p>}
                                                </div>

                                                <div className="off-cta">
                                                    <div className="btn-svg">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clipPath="url(#clip0_899_2456)">
                                                                <path d="M7.94194 3.30806C7.82 3.20532 7.66444 3.14539 7.50306 3.1479C7.34173 3.15035 7.18875 3.21408 7.07641 3.32641C6.96408 3.43875 6.90035 3.59173 6.8979 3.75306C6.89539 3.91444 6.95532 4.07 7.05806 4.19194C7.24871 4.41795 7.44025 4.64308 7.63268 4.86732C9.36449 6.88551 11.1679 8.83211 13.0429 10.7071V9.29289C11.1679 11.1679 9.36449 13.1145 7.63268 15.1327C7.44025 15.3569 7.24871 15.582 7.05806 15.8081C6.95532 15.93 6.89539 16.0856 6.8979 16.2469C6.90034 16.4083 6.96407 16.5613 7.07641 16.6736C7.18875 16.7859 7.34173 16.8497 7.50306 16.8521C7.66444 16.8546 7.82 16.7947 7.94194 16.6919C8.16795 16.5013 8.39308 16.3097 8.61732 16.1173C10.6355 14.3855 12.5821 12.5821 14.4571 10.7071C14.8571 10.3071 14.8571 9.69289 14.4571 9.29289C12.5821 7.41789 10.6355 5.61449 8.61732 3.88268C8.39308 3.69025 8.16795 3.49871 7.94194 3.30806Z" fill="#2B2B2B" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_899_2456">
                                                                    <rect width="20" height="20" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                );

                                return isExternal ? (
                                    <a
                                        href={cardUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`off-card img${index + 1}`}
                                        key={`${card.title || "card"}-${index}`}
                                        style={backgroundStyle}
                                        aria-label="Open"
                                        data-stagger-index={index + 1}
                                    >
                                        {cardContent}
                                    </a>
                                ) : (
                                    <Link
                                        to={cardUrl}
                                        className={`off-card img${index + 1}`}
                                        key={`${card.title || "card"}-${index}`}
                                        style={backgroundStyle}
                                        aria-label="Open"
                                        data-stagger-index={index + 1}
                                    >
                                        {cardContent}
                                    </Link>
                                );
                            })}
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};

export default OfferingsSection;